import { Card, Stack, Text, VStack, useToast } from '@chakra-ui/react';
import { useCreateAgreementNotifications } from '@partiu/api/notifications/hooks';
import { Button } from '@partiu/ui/components/atoms/Button';
import { useNavigate } from 'react-router-dom';
import { useNotificationCentralContext } from '../notification-central.context';
import { IStep } from './interfaces';
import { TestNotificationCard } from './shared';
import { scheduleLabel } from './labels';

export function ConfirmEmailStep({ HeaderComponent }: IStep) {
  const toast = useToast();
  const navigate = useNavigate();

  const { formData } = useNotificationCentralContext();

  const mutation = useCreateAgreementNotifications({
    onSuccess() {
      toast({
        title: 'Notificação agendada!',
        description:
          'O e-mail será enviado na data agendada. O envio pode levar alguns minutos dependendo da quantidade de destinatários.',
        status: 'success',
      });
      navigate('/central-de-notificacoes?tab=email');
    },
    onError() {
      toast({
        title: 'Erro',
        description: 'Não foi possível agendar o e-mail. Por favor entre em contato em: suporte@partiu.com.br',
        status: 'error',
      });
    },
  });

  return (
    <>
      <HeaderComponent title={'Confirmação dos dados'} />
      <Stack direction={['column', 'row']} width={'100%'} alignItems={'flex-start'} spacing={5}>
        <VStack width={{ base: '100%', lg: '50%' }} spacing={5}>
          <Card width="100%" padding={4}>
            <VStack height={'100%'} spacing={5} alignItems={'flex-start'}>
              <Text fontWeight={'bold'}>Assunto do Email</Text>
              <Text fontSize={'sm'}>{formData?.emailSubject}</Text>
              <Text fontWeight={'bold'}>{formData?.type === 'recurring' ? 'Envio recorrente' : 'Data de envio'}</Text>
              <Text fontSize={'sm'}>{scheduleLabel(formData)}</Text>
            </VStack>
            <Button
              marginTop={4}
              width={'100%'}
              colorScheme={'green'}
              isLoading={mutation.isLoading}
              onClick={() => mutation.mutate(formData)}
            >
              Confirmar e agendar
            </Button>
          </Card>
          <TestNotificationCard formData={formData} />
        </VStack>
        <Card width={{ base: '100%', lg: '50%' }}>
          <div dangerouslySetInnerHTML={{ __html: formData?.html }}></div>
        </Card>
      </Stack>
    </>
  );
}
